export default __webpack_public_path__ + "static/media/close.ae8df9f6.svg";